import {Action} from '@ngrx/store';
import {Availability} from '@app/core/models/availability.model';
import {IGetAvailabilitiesParams, IPostAvailabilityPayload} from '@app/modules/shared/services/availability.service';
import {Pagination} from '@app/core/models/pagination.model';

export enum EAvailabilitiesActions {
	GetUserAvailabilities = '[Availabilities] Get User Availabilities',
	GetUserAvailabilitiesSuccess = '[Availabilities] Get User Availabilities Success',
	GetAvailabilities = '[Availabilities] Get Availabilities',
	GetAvailabilitiesSuccess = '[Availabilities] Get Availabilities Success',
	GetApprovedAvailabilities = '[Availabilities] Get Approved Availabilities',
	GetApprovedAvailabilitiesSuccess = '[Availabilities] Get Approved Availabilities Success',

	PostAvailability = '[Availabilities] Post Availability',
	PostAvailabilitySuccess = '[Availabilities] Get Post Availability Success',

	DeleteAvailability = '[Availabilities] Delete Availability',
	DeleteAvailabilitySuccess = '[Availabilities] Get Delete Availability Success',
	ApproveAvailability = '[Availabilities] Approve Availability',
	ApproveAvailabilitySuccess = '[Availabilities] Approve Availability Success',
}

export class GetUserAvailabilities implements Action {
	public readonly type = EAvailabilitiesActions.GetUserAvailabilities;

	constructor(public payload: IGetAvailabilitiesParams = {}, public page_size: number = 200, public page: number = 1) {
	}
}

export class GetUserAvailabilitiesSuccess implements Action {
	public readonly type = EAvailabilitiesActions.GetUserAvailabilitiesSuccess;

	constructor(public availabilities: Availability[]) {
	}
}

export class GetAvailabilities implements Action {
	public readonly type = EAvailabilitiesActions.GetAvailabilities;

	constructor(public payload: IGetAvailabilitiesParams = {}, public page_size: number = 200, public page: number = 1) {
	}
}

export class GetAvailabilitiesSuccess implements Action {
	public readonly type = EAvailabilitiesActions.GetAvailabilitiesSuccess;

	constructor(public availabilities: Availability[]) {
	}
}

export class GetApprovedAvailabilities implements Action {
	public readonly type = EAvailabilitiesActions.GetApprovedAvailabilities;

	constructor(public payload: IGetAvailabilitiesParams = {}, public page_size: number = 200, public page: number = 1) {
	}
}

export class GetApprovedAvailabilitiesSuccess implements Action {
	public readonly type = EAvailabilitiesActions.GetApprovedAvailabilitiesSuccess;

	constructor(public availabilities: Availability[], public pagination: Pagination) {
	}
}

export class PostAvailability implements Action {
	public readonly type = EAvailabilitiesActions.PostAvailability;

	constructor(public payload: IPostAvailabilityPayload) {
	}
}

export class PostAvailabilitySuccess implements Action {
	public readonly type = EAvailabilitiesActions.PostAvailabilitySuccess;

	constructor(public availability: Availability) {
	}
}

export class DeleteAvailability implements Action {
	public readonly type = EAvailabilitiesActions.DeleteAvailability;

	constructor(public id: number) {
	}
}

export class ApproveAvailability implements Action {
	public readonly type = EAvailabilitiesActions.ApproveAvailability;

	constructor(public availability: Availability) {
	}
}

export class ApproveAvailabilitySuccess implements Action {
	public readonly type = EAvailabilitiesActions.ApproveAvailabilitySuccess;

	constructor(public availability: Availability) {
	}
}

export class DeleteAvailabilitySuccess implements Action {
	public readonly type = EAvailabilitiesActions.DeleteAvailabilitySuccess;

	constructor(public availability: Availability) {
	}
}

export type AvailabilitiesActions =
	GetUserAvailabilities |
	GetUserAvailabilitiesSuccess |
	GetAvailabilities |
	GetAvailabilitiesSuccess |
	GetApprovedAvailabilities |
	GetApprovedAvailabilitiesSuccess |
	PostAvailability |
	PostAvailabilitySuccess |
	DeleteAvailability |
	ApproveAvailability |
	ApproveAvailabilitySuccess |
	DeleteAvailabilitySuccess
	;
